module.exports = __webpack_public_path__ + "img/anewitem-female-shoe.a3846e8a.svg";